export const ENTRYPOINT =
  process.env.NODE_ENV !== 'production' ?
  'https://sandbox.dasprojekt.org/api/v2/' :
  'https://api.dasprojekt.org/api/v2/';
